import { SelectDescType } from 'components/SelectWithDescriptions/SelectWithDescriptions';
import { EmployerOption } from 'hooks/webapi/foxentry/useCompaniesByIdMutation';
import { EmploymentStatus } from 'hooks/webapi/useClient';

// Only EMPLOYEE and SELF_EMPLOYED statuses require the employer-details sub-steps
export const areEmployerStepsRequired = (
  employmentTypeStatus?: EmploymentStatus,
): boolean =>
  ['EMPLOYEE', 'SELF_EMPLOYED'].includes(employmentTypeStatus || '');

// Returns the selected profession value only when employer details are actually required
export const parseEmploymentDetails = (
  employmentTypeStatus?: EmploymentStatus,
  profession?: SelectDescType,
) =>
  areEmployerStepsRequired(employmentTypeStatus)
    ? profession?.value
    : undefined;

// Handles both free-text employer names and structured EmployerOption objects from the foxentry API
export const getEmployerName = (
  value: string | EmployerOption | undefined,
): string => {
  return typeof value === 'string' ? value : (value?.data?.name ?? '');
};
